export const SET_BUNDLES = 'SET_BUNDLES'
export const SET_ALL_COUNTRIES = 'SET_ALL_COUNTRIES'
export const SET_TOP_SERVICE_IN_VAS = 'SET_TOP_SERVICE_IN_VAS'
export const SET_IS_ELIGIBLE_FOR_NEW_GIFTING = 'SET_IS_ELIGIBLE_FOR_NEW_GIFTING'
export const SET_BUNDLE_GIFTING_DEST_MSISDN = 'SET_BUNDLE_GIFTING_DEST_MSISDN'
export const SET_PLUS_ELIGIBLE ='SET_PLUS_ELIGIBLE'
export const SET_COMBO_PRODUCTS = 'SET_COMBO_PRODUCTS'
export const SET_COUNTRY_BUNDLES_V2 = 'SET_COUNTRY_BUNDLES_V2'
export const SET_GROUPS = 'SET_GROUPS'
